import { Image } from 'antd';
import { img as defaultAvatar } from '../../assets';

interface StatusAvatarProps {
  src?: string;
  status?: string;
  size?: number;
  /** antd Image preview config; pass `false` to disable. */
  preview?: any;
  fallback?: string;
}

/**
 * Circular user avatar. Used across every table that lists user data.
 */
const StatusAvatar = ({
  src,
  size = 40,
  preview,
  fallback = defaultAvatar,
}: StatusAvatarProps) => {
  return (
    <Image
      src={src || fallback}
      alt="profile"
      width={size}
      height={size}
      style={{ borderRadius: '50%', objectFit: 'cover' }}
      preview={preview}
    />
  );
};

export default StatusAvatar;
